import { LocationMarkerClaim } from "../types";
import { getAuthHeaders } from "../../../common/auth";
import { orderApi } from "../../order/orderApi";
import { createPartyError } from "../util/createPartyError";

export const getPartyToken = async (
    locationMarkerClaims: LocationMarkerClaim[],
    existingToken?: string,
    startFlexTab?: boolean
) => {
    const headers = await getAuthHeaders();
    headers.append("Content-Type", "application/json");
    if (existingToken) {
        headers.append("X-Meandu-Party-Token", existingToken);
    }

    // Use the region embedded in the claim URL (e.g. ?r=us) so the correct
    // regional database is queried regardless of the stored MEANDU_REGION.
    for (const claim of locationMarkerClaims) {
        try {
            const region = new URL(claim.token).searchParams.get("r");
            if (region) {
                headers.set("x-meandu-region", region);
                break;
            }
        } catch {}
    }

    try {
        const response = await orderApi.send(startFlexTab ? "/party/start-flex-tab" : "/party/authenticate", {
            method: "POST",
            body: JSON.stringify(locationMarkerClaims),
            credentials: "include",
            headers,
        });

        const json = await response.json();

        if (response.ok && !json.errorCode) {
            return json;
        }

        throw createPartyError(json);
    } catch (err) {
        throw createPartyError(err || {});
    }
};
